module.exports = __webpack_public_path__ + "img/arrow.2d63246b.svg";